// Line-level diff computer.ts.
import { diffLines } from 'diff';

export interface LineDiff {
  kind: 'added' | 'removed' | 'unchanged';
  lineNumber: number | null;
  content: string;
}

export interface DiffResult {
  lines: LineDiff[];
  addedCount: number;
  removedCount: number;
  firstChangedLine: number | null;
}

export function computeDiff(oldText: string, newText: string): DiffResult {
  const changes = diffLines(oldText, newText);
  const lines: LineDiff[] = [];
  let lineNumber = 1;
  let addedCount = 0;
  let removedCount = 0;
  let firstChangedLine: number | null = null;

  for (const change of changes) {
    const raw = change.value;
    const lineTexts = raw.endsWith('\n') ? raw.slice(0, -1).split('\n') : raw.split('\n');

    if (change.added) {
      for (const content of lineTexts) {
        if (firstChangedLine === null) firstChangedLine = lineNumber;
        lines.push({ kind: 'added', lineNumber, content });
        lineNumber++;
        addedCount++;
      }
    } else if (change.removed) {
      for (const content of lineTexts) {
        if (firstChangedLine === null) firstChangedLine = lineNumber;
        lines.push({ kind: 'removed', lineNumber: null, content });
        removedCount++;
      }
    } else {
      for (const content of lineTexts) {
        lines.push({ kind: 'unchanged', lineNumber, content });
        lineNumber++;
      }
    }
  }

  return { lines, addedCount, removedCount, firstChangedLine };
}
